"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useGameLocale, useT } from "@/lib/i18n";
import { cardImageChain, humanizeCardId } from "@/lib/card-fallback";
export function CardFallback(t0) {
  const $ = _c(21);
  const {
    id,
    upgraded: t1,
    className: t2,
    title
  } = t0;
  const upgraded = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  const t = useT();
  let t3;
  if ($[0] !== id || $[1] !== upgraded) {
    const base = humanizeCardId(id);
    t3 = upgraded && !base.endsWith("+") ? `${base}+` : base;
    $[0] = id;
    $[1] = upgraded;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const name = t3;
  const t4 = title ?? name;
  const t5 = title ?? name;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      containerType: "inline-size"
    };
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = `block ${className}`;
  let t8;
  if ($[4] !== t) {
    t8 = t("Modded card");
    $[4] = t;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== t8) {
    t9 = <span className="text-[7cqw] font-bold uppercase leading-tight tracking-wider text-[var(--text-muted)]">{t8}</span>;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== name) {
    t10 = <span className="line-clamp-3 break-words text-[9cqw] font-semibold leading-tight text-[var(--text-secondary)]">{name}</span>;
    $[8] = name;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== id) {
    t11 = <span className="line-clamp-2 break-all text-[5.5cqw] leading-tight text-[var(--text-muted)]">{id}</span>;
    $[10] = id;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t10 || $[13] !== t11 || $[14] !== t9) {
    t12 = <span className="flex aspect-[400/520] w-full flex-col items-center justify-center gap-[3cqw] overflow-hidden rounded-[5cqw] border border-dashed border-[var(--border-subtle)] bg-[var(--bg-card)] p-[6cqw] text-center">{t9}{t10}{t11}</span>;
    $[12] = t10;
    $[13] = t11;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t4 || $[18] !== t5 || $[19] !== t7) {
    t13 = <span role="img" aria-label={t4} title={t5} style={t6} className={t7}>{t12}</span>;
    $[16] = t12;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
}
export default function CardImage(t0) {
  const $ = _c(23);
  const {
    id,
    upgraded: t1,
    enchantment,
    channel: t2,
    art,
    lang: langOverride,
    alt,
    className: t3,
    fallbackClassName,
    loading: t4,
    eager
  } = t0;
  const upgraded = t1 === undefined ? false : t1;
  const channel = t2 === undefined ? "stable" : t2;
  const className = t3 === undefined ? "" : t3;
  const loading = t4 === undefined ? "lazy" : t4;
  const routeLang = useGameLocale();
  const lang = langOverride ?? routeLang;
  let chain;
  let t5;
  if ($[0] !== art || $[1] !== channel || $[2] !== enchantment || $[3] !== id || $[4] !== lang || $[5] !== upgraded) {
    chain = cardImageChain(id, {
      upgraded,
      enchantment,
      channel,
      lang,
      art
    });
    t5 = chain.join("|");
    $[0] = art;
    $[1] = channel;
    $[2] = enchantment;
    $[3] = id;
    $[4] = lang;
    $[5] = upgraded;
    $[6] = chain;
    $[7] = t5;
  } else {
    chain = $[6];
    t5 = $[7];
  }
  const key = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      key: "",
      index: -1
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const [failed, setFailed] = useState(t6);
  const index = failed.key === key ? failed.index + 1 : 0;
  const src = chain[index];
  if (!src) {
    const t7 = fallbackClassName ?? className;
    const t8 = alt || undefined;
    let t9;
    if ($[9] !== id || $[10] !== t7 || $[11] !== t8 || $[12] !== upgraded) {
      t9 = <CardFallback id={id} upgraded={upgraded} className={t7} title={t8} />;
      $[9] = id;
      $[10] = t7;
      $[11] = t8;
      $[12] = upgraded;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    return t9;
  }
  const t7 = alt ?? "";
  const t8 = eager ? "eager" : loading;
  let t9;
  if ($[14] !== index || $[15] !== key) {
    t9 = () => setFailed({
      key,
      index
    });
    $[14] = index;
    $[15] = key;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== className || $[18] !== src || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <img src={src} alt={t7} className={className} crossOrigin="anonymous" loading={t8} onError={t9} />;
    $[17] = className;
    $[18] = src;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}